// eslint-disable-next-line import/prefer-default-export
export const portfolioActions = {
  PORTFOLIO__FETCH: 'PORTFOLIO__FETCH',
};
